/**
 * Shared sentence-case formatter for check names.
 *
 * v6 baseline convention: canonical engine `check_name` is Title Case
 * (e.g. "Dangling Logic", "Relationship Type Distribution"). Display
 * surfaces (detail page sub-card title bars + cover narrative) render
 * the same name in sentence case ("Dangling logic"). Acronyms (WBS,
 * LOE, P6, …) keep their canonical uppercase form.
 *
 * Single source of truth so cover and detail render identically.
 *
 * @module pdf/helpers/check-name-case
 */

export const ACRONYMS = new Set([
  'WBS', 'LOE', 'CPM', 'DCMA', 'P6', 'EVM',
  'FS', 'FF', 'SS', 'SF',
  'CSV', 'XLSX', 'PDF', 'XER',
]);

/**
 * Convert "Dangling Logic" → "Dangling logic". Preserves acronyms in
 * uppercase ("WBS Coverage" → "WBS coverage", "Float Distribution" →
 * "Float distribution"). Splits on whitespace and dash variants so
 * "Lead/Lag — Detail" tokens survive intact.
 */
export function sentenceCase(s) {
  if (!s) return '';
  const str = String(s);
  const parts = str.split(/(\s+|[—–-])/);
  let firstWord = true;
  return parts.map((part) => {
    if (!part) return '';
    if (/^\s+$|^[—–-]$/.test(part)) return part;
    if (ACRONYMS.has(part.toUpperCase())) {
      firstWord = false;
      return part.toUpperCase();
    }
    if (firstWord) {
      firstWord = false;
      return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
    }
    return part.toLowerCase();
  }).join('');
}
